export default __webpack_public_path__ + "static/3-00945b051f5ffe14de11141d869ec68d.jpg";